// extracted by mini-css-extract-plugin
export default {"infoWrapper":"Info_infoWrapper__9gMio","name":"Info_name__m8PTv","info":"Info_info__FiMSC","contacts":"Info_contacts__6rVcI"};